import 'Styles/modals.scss';
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { replace, goBack } from 'react-router-redux';

import Modal from 'Components/modals/ModalComponent';

import { displayNotification } from 'Actions/UiActions';
import { topicHref, forumHref } from 'Actions/ContextInfoActions';
import { trackGAEvent } from 'Actions/adsActions';
import { deviceType } from 'Utils/deviceType';

import decode from 'Utils/entities';
import { parsePath } from 'Utils/nav/NavHelpers';

export class ShareModalComponent extends React.Component {
	shouldComponentUpdate( nextProps ) {
		return ( nextProps.isOpen !== this.props.isOpen );
	}

	componentDidUpdate( prevProps ) {
		if( prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen ) {
			// using pushState to avoid popstate to be triggered
			history.pushState( { topifyExtra: true, type: 'shareModal' }, '', window.location );
		}
	}

	hideModalAndBack = () => {
		if( this.props.isOpen ) {
			this.props.dispatch( goBack() );
		}
	};

	thisContext() {
		let thisContext = {
				type: null,
				url: null,
				title: null
			},
			path = parsePath( this.props.routing.locationBeforeTransitions.pathname );

		if( path && path.length > 0 ) {
			switch( path[ 1 ] || path[ 0 ] ) {
				case '/':
					return {
						type: 'Home',
						url: this.props.f_url,
						title: decode( this.props.title )
					};

				case 'forums':
					// TODO: implement -> process.env.config.section.home === true
					return {
						type: 'Forum',
						url: this.props.dispatch( forumHref( path[ 2 ] ) ),
						title: decode( this.props.title )
					};

				case 'topics':
					return {
						type: 'Topic',
						url: this.props.dispatch( topicHref( path[ 2 ] ) ),
						title: decode( this.props.title )
					};
			}
		}
		return thisContext;
	}

	shareAction( type ) {
		let thisContext = this.thisContext(),
			closeThis = true;

		switch( type ) {
			case 'facebook':
				window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent( thisContext.url ) );
				break;

			case 'twitter':
				window.open('https://twitter.com/home?status=' + encodeURIComponent( thisContext.url ) );
				break;

			case 'google':
				window.open('https://plus.google.com/share?url=' + encodeURIComponent( thisContext.url ) );
				break;

			case 'sms':
			case 'email':
				// do nothing but do not exit
				break;

			case 'clipboard':
				closeThis = false;
				this.clipboardText.textContent = thisContext.url;
				this.clipboard.classList.add( 'hidden' );
				this.clipboardText.classList.remove( 'hidden' );

				// is element selectable?
				if( this.clipboardText ) {
					// select text
					let range = document.createRange();
					range.selectNodeContents( this.clipboardText );

					let selection = window.getSelection();
					// ensure selection is empty
					selection.removeAllRanges();
					// load our selected text
					selection.addRange( range );

					try {
						// copy text
						let copied = document.execCommand( 'copy' );

						if( copied ) {
							selection.removeAllRanges();
							displayNotification( 'info', 'Link copied', { timeout: 1000 } );
							closeThis = true;
						} else {
							throw false;
						}

					} catch( err ) {
						displayNotification( 'warning', 'You have to tap and copy the link manually', { force: true, timeout: 4000 } );
					}
				}

				break;

			default:
			// Do nothing.
				return;
		}

		// send analytics of what and how is shared
		this.props.dispatch( trackGAEvent( false, ( thisContext.type ? thisContext.type.toLowerCase() : 'unk' ), 'userAction', 'sharing' ) );
		this.props.dispatch( trackGAEvent( false, type, 'userAction', 'sharingAction' ) );

		if( closeThis ) {
			// and close
			this.hideModalAndBack();
		}
	}

	buildShareButtons() {
		let thisContext = this.thisContext(),
		email = `mailto:?subject=${ encodeURIComponent( thisContext.title ) }&body=${ encodeURIComponent( thisContext.url + "\r\n" ) }`,
		deviceInfo = deviceType(),
		smsFormat = deviceInfo.os.platform.ios && deviceInfo.browser.engine === 'Safari' ? '&' : '?',
		sms = `sms:${ smsFormat }body=${ thisContext.url }`;

		let buttons = [
			<input key="clipboard" className="button clipboard" type="button" value="copy to clipboard" ref={ (c) => this.clipboard = c } onClick={ () => this.shareAction( 'clipboard' ) } />,
			<span key="clipboard-text" className="clipboard-text hidden" ref={ (t) => this.clipboardText = t } />,
			<input key="fb" className="button facebook" type="button" value="Facebook" onClick={ () => this.shareAction( 'facebook' ) }/>,
			<input key="g+" className="button google" type="button" value="Google" onClick={ () => this.shareAction( 'google' ) } />,
			<input key="tw" className="button twitter" type="button" value="Twitter" onClick={ () => this.shareAction( 'twitter' ) } />,
			<a key="email" className="button email" href={ email } onClick={ () => this.shareAction( 'email' ) }>email</a>,
			<a key="sms" className="button sms" href={ sms } onClick={ () => this.shareAction( 'sms' ) }>sms</a>
		];

		return <div key="social-buttons" className="modal-buttons social-buttons block-buttons">{ buttons }</div>;
	}

	render() {
		let thisContext = this.thisContext();

		return (
			<Modal isOpen={this.props.isOpen} onClickOutsideWindow={this.hideModalAndBack}>
				<div className="share-modal">
					<h2>Share</h2>
					<h3>{ thisContext.title }</h3>
					<div className="modal-buttons">
						{ this.buildShareButtons() }
					</div>
					<div className="modal-buttons">
						<input className="cancel-button" type="button" value="Cancel" onClick={ this.hideModalAndBack }/>
					</div>
				</div>
			</Modal>
		);
	}
}

ShareModalComponent.propTypes = {
	isOpen: PropTypes.bool.isRequired
};

const mapStateToProps = ( state ) => {
	return {
		isOpen: state.ui.shareModal.opened,
		routing: state.routing,
		title: state.meta.title || '',
		f_url: state.topifyPresets.forumSite.f_url
	}
};

export default connect( mapStateToProps )( ShareModalComponent );


// WEBPACK FOOTER //
// ./src/components/modals/ShareLinkComponent.js